import React from 'react';
import { Chip, useTheme, alpha } from '@mui/material';
import { fontWeight } from '../../utils/accounting/styles';

const STATUS_MAP = {
  status: {
    PENDING: { label: 'Pending', color: 'warning' },
    PENDING_APPROVAL: { label: 'Pending', color: 'warning' },
    APPROVED: { label: 'Approved', color: 'success' },
    REJECTED: { label: 'Rejected', color: 'error' },
    PAID: { label: 'Paid', color: 'info' },
    COMPLETED: { label: 'Completed', color: 'success' },
    IN_PROGRESS: { label: 'In Progress', color: 'info' },
    CANCELLED: { label: 'Cancelled', color: 'default' },
    DRAFT: { label: 'Draft', color: 'default' },
    OPEN: { label: 'Open', color: 'info' },
    FILED: { label: 'Filed', color: 'success' },
    REVERSED: { label: 'Reversed', color: 'default' },
    SKIPPED: { label: 'Skipped', color: 'default' },
  },
  cheque: {
    ISSUED: { label: 'Issued', color: 'warning' },
    CLEARED: { label: 'Cleared', color: 'success' },
    BOUNCED: { label: 'Bounced', color: 'error' },
    CANCELLED: { label: 'Cancelled', color: 'default' },
  },
  expenseType: {
    PAID: { label: 'Paid now', color: 'info' },
    PAYABLE: { label: 'Bill', color: 'warning' },
    RETURN: { label: 'Refund', color: 'success' },
  },
  commissionStatus: {
    PENDING: { label: 'Pending', color: 'default' },
    PAYABLE: { label: 'Payable', color: 'warning' },
    PAID: { label: 'Paid', color: 'success' },
    CANCELLED: { label: 'Cancelled', color: 'error' },
    REVERSED: { label: 'Reversed', color: 'error' },
  },
  reconciliation: {
    DUE: { label: 'Due', color: 'warning' },
    OK: { label: 'OK', color: 'success' },
    NEW: { label: 'New', color: 'info' },
    COMPLETED: { label: 'Completed', color: 'success' },
    IN_PROGRESS: { label: 'In Progress', color: 'info' },
  },
  drawingType: {
    DRAWING: { label: 'Drawing', color: 'primary' },
    DIVIDEND: { label: 'Dividend', color: 'info' },
  },
  partnerRole: {
    ACTIVE: { label: 'Active', color: 'success' },
    SILENT: { label: 'Silent', color: 'default' },
  },
};

// Alias for convenience
STATUS_MAP.reconciliationStatus = STATUS_MAP.reconciliation;

// Tinted chip: readable in light and dark themes. `tone` + `label` render an ad-hoc tag (e.g. "Unpaid").
const StatusChip = ({ type = 'status', value, tone, label }) => {
  const theme = useTheme();
  const map = STATUS_MAP[type] || STATUS_MAP.status;
  const config = tone ? { label, color: tone } : (map[value] || { label: value, color: 'default' });
  const main = config.color === 'default' || !theme.palette[config.color]
    ? theme.palette.text.secondary
    : theme.palette[config.color][theme.palette.mode === 'dark' ? 'light' : 'dark'];

  return (
    <Chip
      label={config.label}
      size="small"
      sx={{
        fontSize: '0.75rem',
        fontWeight: fontWeight.semibold,
        height: 24,
        color: main,
        bgcolor: alpha(main, theme.palette.mode === 'dark' ? 0.18 : 0.12),
        border: `1px solid ${alpha(main, 0.35)}`,
        '& .MuiChip-label': { px: 1 },
      }}
    />
  );
};

export default StatusChip;
